module.exports = __webpack_public_path__ + "img/mehrsprachigkeit.dda7acbd.svg";